import { mapGetters } from 'vuex';
import reauthorization from '~/mixins/reauthorization.js';

export default {
  mixins: [reauthorization],
  computed: {
    ...mapGetters({
      reauthorizationClosed: 'profile/reauthorization/reauthorizationClosed',
      shouldSeeReauthorization: 'profile/reauthorization/shouldSeeReauthorization',
      partnerBefore: 'profile/reauthorization/partnerBeforeReauthorization',
      mainPartners: 'profile/authorization/mainPartners'
    }),
    isAuthorizationCase() {
      return (
        !this.shouldSeeReauthorization ||
        this.userAppData.findIndex(setting => setting.name === 'authorization_modal_shown') === -1
      );
    }
  }
};
